import { LegalLayout, LegalSection, PH } from "../components/LegalLayout";

export default function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" path="/confidentialite" testid="page-confidentialite">
      <LegalSection n="1" title="Responsable du traitement">
        <p>Le responsable du traitement des données est <PH>NOM DE LA SOCIÉTÉ</PH>, <PH>ADRESSE</PH>. Contact : <PH>privacy@streateat.com</PH>.</p>
      </LegalSection>

      <LegalSection n="2" title="Données collectées">
        <ul className="list-disc pl-5 space-y-1">
          <li>Données de compte : nom, adresse e-mail, mot de passe (chiffré).</li>
          <li>Données des fiches foodtrucks : nom, cuisine, ville, emplacements, horaires, photos.</li>
          <li>Données de paiement : gérées par Stripe (nous ne stockons aucune carte).</li>
          <li>Données d'usage : favoris, avis, abonnements aux alertes, statistiques de vues.</li>
          <li>Données techniques : logs, cookies (voir section Cookies).</li>
        </ul>
      </LegalSection>

      <LegalSection n="3" title="Finalités et bases légales">
        <ul className="list-disc pl-5 space-y-1">
          <li>Fourniture du service et gestion du compte — exécution du contrat.</li>
          <li>Traitement des abonnements et paiements — exécution du contrat / obligation légale.</li>
          <li>Envoi d'alertes et notifications — consentement / intérêt légitime.</li>
          <li>Amélioration du service et statistiques — intérêt légitime.</li>
        </ul>
      </LegalSection>

      <LegalSection n="4" title="Destinataires et sous-traitants">
        <p>Vos données peuvent être communiquées à nos sous-traitants strictement nécessaires au fonctionnement du Service :</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><b>Stripe</b> — traitement des paiements.</li>
          <li><b>Resend</b> — envoi des e-mails transactionnels.</li>
          <li><b>OpenStreetMap / Nominatim</b> — géolocalisation et cartographie.</li>
          <li>Hébergeur : <PH>NOM DE L'HÉBERGEUR</PH>.</li>
        </ul>
      </LegalSection>

      <LegalSection n="5" title="Durée de conservation">
        <p>Les données de compte sont conservées tant que le compte est actif, puis <PH>DURÉE, ex. 3 ans</PH> après la dernière activité. Les données de facturation sont conservées <PH>10 ans</PH> conformément aux obligations comptables.</p>
      </LegalSection>

      <LegalSection n="6" title="Cookies">
        <p>Le Site utilise des cookies et technologies similaires (stockage local) nécessaires au fonctionnement (session, préférences). <PH>Décrivez ici les éventuels cookies de mesure d'audience et le recueil du consentement.</PH></p>
      </LegalSection>

      <LegalSection n="7" title="Vos droits (RGPD)">
        <p>Vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données, ainsi que du droit de définir des directives post-mortem. Pour les exercer, écrivez à <PH>privacy@streateat.com</PH>. Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).</p>
      </LegalSection>

      <LegalSection n="8" title="Sécurité">
        <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées (mots de passe chiffrés, connexions sécurisées) pour protéger vos données contre tout accès non autorisé.</p>
      </LegalSection>

      <LegalSection n="9" title="Contact">
        <p>Pour toute question relative à vos données personnelles : <PH>privacy@streateat.com</PH>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
